import { CompanyAccountModelDto } from '@treasury/api/channel';
import { emptyCompanyAccount } from '../company/company-account.entity';

export const nullAccount: CompanyAccountModelDto = {
    ...emptyCompanyAccount,
    cifNumber: '0',
    type: 'Checking',
};
